import React, { useEffect, useState } from "react";
import Select from "react-select";
import nationalities from "./nationalities.json";
import { countries } from "countries-list";
import { useTranslation } from "react-i18next";

const formatOptionLabel = (data) => (
  <div className="flex items-center text-center text-14 w-full">
    {countries[data.alpha_2_code] && (
      <span className="pr-8 text-18">{countries[data.alpha_2_code].emoji}</span>
    )}
    <span>{data.nationality}</span>
    <span className="pl-8">( {`${data.en_short_name}`} )</span>
  </div>
);

const NationalityPicker = (props) => {
  const { t } = useTranslation();
  const [value, setValue] = useState("");
  const [options, setOptions] = useState([]);
  const [formattedNationalities] = useState(
    nationalities.map((nationality) => ({
      label: nationality.nationality,
      value: nationality.alpha_2_code,
      ...nationality,
    })).sort((a, b) => a.label.localeCompare(b.label))
  );

  useEffect(() => {
    setOptions(formattedNationalities);
    setValue(
      formattedNationalities.filter(
        (nationality) => nationality.value === props.getNationality
      )
    );
  }, [formattedNationalities, props.getNationality]);

  const filterOption = (option, inputValue) => {
    if (inputValue.length === 0) return true;

    return (
      option.value.toLowerCase().includes(inputValue.toLowerCase()) ||
      option.data.nationality.includes(
        inputValue.charAt(0).toUpperCase() + inputValue.slice(1)
      ) ||
      option.data.en_short_name.includes(
        inputValue.charAt(0).toUpperCase() + inputValue.slice(1)
      ) ||
      option.data.alpha_2_code.includes(inputValue.toUpperCase()) ||
      option.data.alpha_3_code.includes(inputValue.toUpperCase())
    );
  };

  return (
    <div className="w-full h-full relative">
      {options.length !== 0 && value && (
        <Select
          autoFocus
          options={options}
          value={value}
          onChange={props.nationalityHandler}
          components={{
            Placeholder: () => t("ENTER_NATIONALITY"),
            DropdownIndicator: () => null,
            IndicatorSeparator: () => null,
          }}
          isSearchable={true}
          isClearable={true}
          filterOption={filterOption}
          styles={{
            control: (styles) => ({
              ...styles,
              backgroundColor: "transparent",
              width: "100%",
              height: "50px",
              paddingLeft: "40px",
              paddingRight: "10px",
              outline: "none",
              border: "none",
              borderColor: "inherit",
              boxShadow: "none",
              position: "fixed",
              ":focused": {
                outline: "none",
                border: "none",
              },
              ":hover": {
                outline: "none",
                border: "none",
                boxShadow: "none",
              },
              ":active": {
                outline: "none",
                border: "none",
              },
              ":focus": {
                outline: "none",
                border: "none",
              },
            }),
            option: (styles, { data, isDisabled, isFocused, isSelected }) => {
              return {
                ...styles,
                textAlign: "left",
                display: "inline-flex",
                width: "100%",
                color: props.styles?.color,
                backgroundColor: (isSelected || isFocused) ? '#B2D4FF' : '#FFFFFF',
              };
            },
            menu: (styles) => {
              return {
                display: "inline-flex",
                width: "100%",
                marginTop: "50px",
              };
            },
            menuList: (styles) => {
              return {
                ...styles,
                width: "100%",
                maxHeight: "calc(100vh - 50px)",
                borderTop: "1px #e1e1e1 solid",
              };
            },
            indicatorContainer: (styles) => {
              return {
                ...styles,
                padding: "0px",
              };
            },
            indicatorsContainer: (styles) => {
              return {
                ...styles,
                display: "none",
              };
            },
            valueContainer: (styles) => {
              return {
                ...styles,
                display: "block",
              };
            },
            input: (styles) => {
              return {
                ...styles,
                width: "100%",
                // height: "44px",
                outline: "none",
                border: "none",
                fontSize: "14px",
                color: "inherit",
                display: "block",
                ":active": {
                  outline: "none",
                  border: "none",
                },
                ":focus": {
                  outline: "none",
                  border: "none",
                },
                ":focused": {
                  outline: "none",
                  border: "none",
                },
                ":hover": {
                  outline: "none",
                  border: "none",
                  boxShadow: "none",
                },
              };
            },
          }}
          formatOptionLabel={formatOptionLabel}
          menuIsOpen
        />
      )}
    </div>
  );
};

export default NationalityPicker;
